module.exports = __webpack_public_path__ + "static/media/iot-consultation02.0fb84438.jpg";